import { ROUTES } from "@/constants";

export default [
  {
    path: ROUTES.UPDATE_DATA,
    name: "update-data",
    meta: {
      title: "Обновление данных",
      authRequired: true,
    },
    component: () => import("@/modules/update-data/views/index.vue"),
  },
];
